/** 简体中文 — 品牌/导航/页脚等已填；长文案可与 en 相同，可自行替换 */
export default {
  brand: {
    linePrimaryZh: '深圳市尚音芯声科技有限公司',
    lineSecondaryEn: 'Shenzhen Shangyin Xinsheng Technology Co., Ltd.',
    singleLine: 'Shenzhen Shangyin Xinsheng Technology Co., Ltd.',
  },
  site: {
    documentTitle: '深圳市尚音芯声科技有限公司',
  },
  nav: {
    home: '首页',
    productCenter: '产品中心',
  },
  footer: {
    copyright1: '<span style="margin: 0;text-align: center;font-size: 13px;line-height: 1.6;color: #b0b0b0;letter-spacing: 0.02em;"> <span >Copyright © 2026 深圳市尚音芯声科技有限公司 </span></span>',
    copyright2: '<span style="margin: 0;text-align: center;font-size: 13px;line-height: 1.6;color: #b0b0b0;letter-spacing: 0.02em;cursor:pointer;"> 粤ICP备17114376号</span>'
   
    ,
  },
  lang: {
    zh: '简体中文',
    ja: '日本語',
    en: 'English',
  },
  category: {
    sectionTitle: '产品类别',
    power: '移动电源',
    wearables: '智能穿戴',
    tws: 'TWS耳机',
    speaker: '蓝牙音箱',
    others: '其他',
  },
  home: {
    popularTitle: '热门产品',
    popular: {
      p1: 'B18 充电宝',
      p2: 'S9 智能手表',
      p3: 'H15 耳机',
      p4: 'BX09 蓝牙耳机',
    },
    aboutTitle: '关于我们',
    about1_html:
      '<span style="line-height:58px;">深圳市尚音芯声科技有限公司成立于2025年12月23日，<span style=" display: inline;font-size: 25px;color: #3b71ca;font-weight: 500;">是一家扎根深圳、聚焦3C数码与<br/>消费电子领域，构建B端供应链赋能与C端日本跨境运营双轮驱动模式的创新型科技企业。</span><br/>我们以扎实的产业服务能力与敏锐的市场洞察力，实现国内海外市场全域布局。</span>',
    about2_html:
      '<span style="line-height:58px;"><span style=" display: inline;font-size: 25px;color: #3b71ca;font-weight: 500;">面向B端市场，</span>我们专注于优质供应链深度服务，<span style=" display: inline;font-size: 25px;color: #3b71ca;font-weight: 500;">整合300家+优质供应商资源，</span>构建了稳定、高效且具品质保障的供应链体系;<span style=" display: inline;font-size: 25px;color: #3b71ca;font-weight: 500;">同时配备3C产品行业前沿的技术研发团队，为合作企业提供从产品研发到供应链整合的全链路赋能。</span>依托强大的渠道整合能力，我们不仅稳固国内市场服务，更布局日本主要电商平台及线下商超渠道，全方位助力客户拓展国内外市场。</span></span>',
    about3_html:
      '<span style="line-height:58px;"><span style=" display: inline;font-size: 25px;color: #3b71ca;font-weight: 500;">面向C端市场，</span>公司深耕日本3C线上消费市场，精准把握日本消费者对品质与科技的核心需求。目前，<span style=" display: inline;font-size: 25px;color: #3b71ca;font-weight: 500;">我们在日本各大主流电商平台经营的店铺链接均表现良好，具备成熟的跨境运营与品牌打造能力，</span>持续为日本市场输送高性价比的中国优质3C产品。</span>',
    about4_html:
      '<span style="line-height:58px;">未来，<span style=" display: inline;font-size: 25px;color: #3b71ca;font-weight: 500;">尚音芯声将持续深化B+C端协同优势，</span>以优质供应链为基石，以技术研发为引擎，以精细化跨境运营为抓手，致力成为链接中日3C产业、全链路赋能产业发展的新锐标杆企业。</span>',
    contactAddressTitle: '公司地址',
    contactAddressText:
      '深圳市龙华区大浪街道汇亿财富中心703F',
    contactEmailTitle: '邮箱',
    contactEmailText: 'SERVICE@SHANGYINXINSHENG.COM',
  },
  common: {
    details: '详情',
    contactUs: '联系我们',
  },
  productCenter: {
    titles: {
      power: '移动电源',
      wearables: '智能穿戴',
      twsHeadphones: 'TWS 耳机',
      speaker: '蓝牙音箱',
      others: '其他',
    },
  },
  productName: {
    power1: 'B18 充电宝',
    power2: 'CDB-006 充电宝',
    power3: 'B15 充电宝',
    power4: '2005B 充电宝',
    power5: 'B10 双线电源',
    power6: 'CDB-006 移动电源',
    power7: 'B11 移动电源',
    power8: 'V11 磁吸电宝',
    power9: 'B12 双磁快充电宝',
    smart1: 'S11<br>智能手表',
    smart2: 'S9<br>智能手表',
    smart3: 'ZL99J<br>智能手表',
    smart4: 'Z145<br>智能手表',
    smart5: 'ZL02CPRO<br>智能手表',
    smart6: 'ZL73J<br>智能手表',
    smart7: 'ZL54J<br>智能手表',
    smart8: 'ZL169<br>智能手表',
    smart9: 'Z136<br>智能手表',
    smart10: 'Z123<br>智能手表',
    tws1: 'T8<br> 蓝牙耳机',
    tws2: 'BX09<br> 无线蓝牙耳机',
    tws3: 'H15<br> 蓝牙耳机',
    tws4: 'S13<br> 蓝牙耳机',
    tws5: 'S58<br> 蓝牙耳机',
    tws6: 'S57<br> 蓝牙耳机',
    tws7: 'W09<br> 蓝牙耳机',
    tws8: 'E09<br> 蓝牙耳机',
    tws9: 'H10<br> 智能仓双麦ENC',
    tws10: 'T08<br> 蓝牙耳机',
    tws11: 'Y12<br> 骨传导耳机',
    tws12: 'S75<br> 蓝牙耳机',
    tws13: 'H35<br> 蓝牙耳机显示屏',
    speaker1: 'BT-2928<br>蓝牙音箱',
    speaker2: 'BT-2612<br>蓝牙音箱',
    speaker3: 'BT-2602 RGB<br>蓝牙音箱',
    others1: 'F11<br>挂脖风扇',
    others2: 'TP107C1<br> 氮化镓充电头',
    others3: 'TP65C2U1<br> 氮化镓充电头',
    others4: 'OJD-88<br> 四合一无线充',
    others5: 'KR8<br>挂脖风扇',
    others6: 'S70<br> 三合一剃须刀',
    others7: 'H13<br> 无线折叠吸尘器',
    others8: 'YL-001<br>加湿器',
    others9: 'P4<br>苹果笔',
    others10: 'P3<br>苹果笔',
    others11: 'E03<br>苹果笔',
    others12: 'MV53 <br>高速吹风机',
    others13: 'ML-JB-01 <br>直发器',
    others14: 'ZY-3101 <br>车载吸尘器',
    others15: 'WETAG <br>防丟器',
    others16: 'S108 <br>剃须刀',
    others17: 'S109 <br>三合一剃须刀',
  },
  detail: {
    featuresTitle: '产品卖点',
    ariaPrev: 'Previous image',
    ariaNext: 'Next image',
    thumbCarousel: 'Product thumbnails',
    p1: {
      name_html: 'B18<br/>充电宝',
      features_html:
        '三线，双USB-A口<br/>大屏幕数显，自带户外挂绳',
      specs: [
        { label: '型号', value: 'B18' },
        { label: '材质', value: 'PC + ABS' },
        { label: '电池', value: '146074*1' },
        { label: 'Type-C口输入 / MICRO口输入', value: '5V 2A' },
        { label: 'USB自带线输入', value: '5V 2A' },
        { label: 'USB1-2口输出', value: '5V 2A' },
        { label: 'Lighning自带线输出', value: '5V 2A' },
        { label: 'Type-C自带线输出', value: '5V2A' },
      ],
    },
    p2: {
      name_html: 'S9 智能手表',
      features_html: '',
      specs: [
        { label: '显示屏尺寸', value: '2.01英寸屏' },
        { label: '屏幕像素', value: '240*296' },
        { label: '屏幕类型', value: 'IPS TFT' },
        { label: 'PPI', value: '190' },
        { label: '容量 (电流*时间)', value: '1000mAh' },
        { label: '电量 (电量*电压)', value: '3.8Wh' },
        { label: '使用时间', value: '20-30天' },
        { label: '待机时间', value: '80-120天' },
        { label: '机身', value: 'PC + ABS' },
        { label: '表带', value: '硅胶' },
        { label: 'CPU', value: '杰理7074A5' },
        { label: '蓝牙', value: '蓝牙5.3+EDR' },
        { label: '触摸', value: '全触全贴OGS' },
        { label: '安卓', value: '系统版本6.0以上' },
        { label: '苹果', value: '系统版本9.0以上' },
      ],
    },
    p3: {
      name_html: 'H15<br/> 蓝牙耳机',
      features_html:
        '不堵塞耳道、不挑耳型、戴眼镜友好、<br/>耳道通风、防掉落、佩戴舒适、户外更安全',
      specs: [
        { label: 'ANC/ENC', value: 'N/A' },
        { label: '防水等级', value: 'IPX4' },
        { label: '声道系统', value: '双声道' },
        { label: '蓝牙版本', value: 'V6.0' },
        { label: '蓝牙有效距离', value: '>10米' },
        { label: '频率响应', value: '20Hz - 20KHz' },
        { label: '充电接口', value: 'Type-C' },
        { label: '接收灵敏度(TYP)', value: '-94dbm' },
      ],
    },
    p4: {
      name_html: 'BX09<br/> 蓝牙耳机',
      features_html:
        '最新蓝牙5.3版本，功耗更低音质更佳 ,采用高性能喇叭，<br/>通话声音更清楚，听音乐立体音质更震憾,采用大容量电池，<br/>打电话听音乐时间更长久',
      specs: [
        { label: '耳机尺寸', value: '30.7*18.7*19.2mm' },
        { label: '充电仓尺寸', value: '57.0*46.0*23.5mm' },
        { label: '蓝牙', value: 'Bluetooth V5.3' },
        { label: '传输距离', value: '> 10米' },
        { label: '待机时间', value: '约90天' },
        { label: '外壳材质', value: 'ABS' },
        { label: '充电仓电池容量', value: '851327/300mAh' },
        { label: '蓝牙工作频率', value: '2.402GHz-2.480GHz' },
      ],
    },
  },
}
